import type { GetRequestOptions, IFetchService } from "app/services/fetchService";

import type { IFindAppsDescriptionDto } from "../../types/descriptionDto";

export default function createAppsSearchFiltersApiService(fetchService: IFetchService) {
    return {
        fetchDescription(options?: Readonly<GetRequestOptions>): Promise<IFindAppsDescriptionDto> {
            return fetchService.get("/sales-api/search-apps/filters/description", undefined, options);
        },
    };
}
